import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AtoresPage = lazy(() => import('../pages/atores/page'));
const TreinadoresPage = lazy(() => import('../pages/treinadores/page'));
const EstudantesPage = lazy(() => import('../pages/estudantes/page'));
const AtletasPage = lazy(() => import('../pages/atletas/page'));
const DefesaAtaquePage = lazy(() => import('../pages/defesa-ataque/page'));
const TreinadorPage = lazy(() => import('../pages/treinador/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/atores',
    element: <AtoresPage />,
  },
  {
    path: '/treinadores',
    element: <TreinadoresPage />,
  },
  {
    path: '/estudantes',
    element: <EstudantesPage />,
  },
  {
    path: '/atletas',
    element: <AtletasPage />,
  },
  {
    path: '/defesa-ataque',
    element: <DefesaAtaquePage />,
  },
  {
    path: '/o-treinador',
    element: <TreinadorPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;